var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloppyDisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 14.25V4.75C2.75 3.64543 3.64543 2.75 4.75 2.75H12.4216C12.952 2.75 13.4607 2.96071 13.8358 3.33579L15.6642 5.16421C16.0393 5.53929 16.25 6.04799 16.25 6.57843V14.25C16.25 15.3546 15.3546 16.25 14.25 16.25H4.75C3.64543 16.25 2.75 15.3546 2.75 14.25Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 7.25H11.9C12.2314 7.25 12.5 6.98137 12.5 6.65V3.35C12.5 3.01863 12.2314 2.75 11.9 2.75H7.1C6.76863 2.75 6.5 3.01863 6.5 3.35V6.65C6.5 6.98137 6.76863 7.25 7.1 7.25Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.85V16.25H14V10.85C14 10.5186 13.7314 10.25 13.4 10.25H5.6C5.26863 10.25 5 10.5186 5 10.85Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/floppy-disk.1d73a11eaaff077d3f0b76d2ce1a937d.svg";
export { ForwardRef as ReactComponent };